exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".receipt-module{margin:15px auto 0;width:400px}.receipt-module table{border:1px solid #ccc;background-color:#fff;font-size:.8em}.receipt-module table thead th{font-size:1.25em;font-weight:700;color:#05a;text-align:center}.receipt-module table tbody th{width:75px;text-align:right;font-weight:700}.receipt-module table tbody td{text-align:left}.receipt-module table th{padding:0 1em;border:none}.receipt-module table td{border:none;padding:0 1em 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Modules/Receipt/Receipt.less
// module id = 1602
// module chunks = 0